import React from 'react';
import './styles.css';
import { Col } from 'antd';

const ActivationRoleDescription = ({ name, description }) => (
  <Col
    span={6}
    type="flex"
    align="middle"
    justify="center"
    className="activation-role-description-container"
  >
    <Col span={18}>
      <div className="content-description-wrapper">
        <div className="text-label">{name}</div>
        <h3 className="text-description">{description}</h3>
      </div>
    </Col>
  </Col>
);
ActivationRoleDescription.defaultProps = {
  name: '',
  description: '',
};

export default ActivationRoleDescription;
